/**************************************************
 * Nombre:       Seccion_Crm
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import Main_Crm from "../../Modulo_CRM/Componentes/Main_Crm";
import {useContext, useEffect, useState} from "react";
import {usuarioContext} from "../../App";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";

const Seccion_Crm = () => {
    const cData = useContext(usuarioContext)
    const [configuracion, setConfiguracion] = useState({});

    useEffect(() => {

        if (cData.configCrm[0]) {
            setConfiguracion(cData.configCrm[0]);
        } else {

            obtenerCol('configCrm').then((dox) => {
                if (dox.res && dox.data.length > 0) {
                    setConfiguracion(dox.data[0]);
                }
            })

        }

    }, [cData]);
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Main_Crm config={configuracion}/>
            </Grid>

        </Grid>
    )

}
export default Seccion_Crm    